var BlockCompiler = require("../../compiler/compiler.js");
var CBlockType = require("../../compiler/types.js");
var CoreFunctions = require("../../compiler/corefunc.js");

BlockCompiler.defineBlock("event_whengamestarts", {
  type: CBlockType.STARTER_HAT,
  func: function (utils) {
    var insideCode = utils.getHatContents("");
    var fullInsideCode = CoreFunctions.putThreadStack(utils, insideCode);

    var BLOCK_ID = JSON.stringify(utils.getID());

    var code = "";
    code += `sprite.addStackListener(`;
    code += `"started",`;
    code += BLOCK_ID + ",";
    code += `async function () {`;
    code += fullInsideCode;
    code += `});`;

    return code;
  },
});
